import { render, staticRenderFns } from "./TaskTemplateDetailNew.vue?vue&type=template&id=ccea41b2&"
import script from "./TaskTemplateDetailNew.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateDetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports